import { FC } from 'react';
import { Link } from 'dibs-elements/exports/Link';
import { trackPhotoInteraction } from './helpers/interiorsPhotosTracking';

import styles from './RailThumbnailLink.scss';

type Props = {
    dataTn: string;
    href: string;
    title: string;
    clickTrackingLabel: string;
    imgSrc: string;
};

const RailThumbnailLink: FC<Props> = props => {
    const { dataTn, href, title, clickTrackingLabel, imgSrc } = props;
    return (
        <Link
            key={dataTn}
            dataTn={dataTn}
            buyerLinkType="linkNoDecoration"
            className={styles.link}
            href={href}
            ariaLabel={title}
            onClick={() => {
                trackPhotoInteraction({
                    action: 'item thumbnail clicked',
                    label: clickTrackingLabel,
                });
            }}
        >
            <img src={imgSrc} className={styles.image} alt={title} />
        </Link>
    );
};

export default RailThumbnailLink;
